// ********************************************************
//
// IMPORT
//
// ******************************************************** 
import AssetService from '@/services/AssetService'
import GLTFService from '@/services/GLTFService' 
import '@/services/ResizeService'
// import '@/services/AnalyticsService'
import Raf from '@/helpers/Raf'
import Env from '@/config/env'
 
import ImageService from '@/services/ImageService'
import assetManifest from '@/config/asset' 

import store from '@/store'
import { LOAD } from '@/config/app'


let mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
let reduced_motion = mediaQuery.matches

if(store.state.app.reduced_motion !== null){
  reduced_motion = store.state.app.reduced_motion
}

mediaQuery.addListener(()=>{ store.commit('app/setReducedMotion', mediaQuery.matches) })
store.commit('app/setReducedMotion', reduced_motion)


// ********************************************************
//
// DOCUMENT
//
// ********************************************************
const loadDocument = function() {
  return new Promise((resolve) => {
    const onReady = function() {
      setTimeout(resolve, 1)
    }

    if (document.readyState === 'complete') {
      onReady()
    } else {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          onReady()
        }
      }
    }
  })
}

function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
// ********************************************************
//
// APP
//
// ********************************************************
async function initApp() {


  // LOAD FRAMEWORK
  store.commit('app/setLoadState', LOAD.STATES.FRAMEWORK_LOADING)
  await loadDocument()
  Raf.start()
  await import('./main')
  store.commit('app/setLoadState', LOAD.STATES.FRAMEWORK_LOADED)

  await timeout(0)


  const unsupported = Env.ie
  if( unsupported ){
     
    store.commit('app/setLoadState', LOAD.STATES.COMPLETE)
    store.dispatch('app/getVersion') 

  } else {

    // LOAD.GROUPS.MAIN
    store.commit('app/setLoadState', LOAD.STATES.MAIN_LOADING)
    // store.commit('app/setLoadStep', 'sound')
    // await SoundService.load(soundManifest)
    await AssetService.load(assetManifest, 2, LOAD.GROUPS.MAIN)
    await ImageService.load(assetManifest, 2, LOAD.GROUPS.MAIN)
    store.commit('app/setLoadState', LOAD.STATES.MAIN_LOADED)

    await timeout(0)

    // LOAD.GROUPS.BUBBLE
    store.commit('app/setLoadState', LOAD.STATES.BUBBLE_LOADING)
    await GLTFService.load(assetManifest, 1, LOAD.GROUPS.BUBBLE)
    store.commit('app/setLoadState', LOAD.STATES.BUBBLE_LOADED)

    await timeout(0)

    // LOAD.GROUPS.CHARACTER_LOADING
    store.commit('app/setLoadState', LOAD.STATES.CHARACTER_LOADING)
    await GLTFService.load(assetManifest, 1, LOAD.GROUPS.CHARACTER)
    store.commit('app/setLoadState', LOAD.STATES.CHARACTER_LOADED)

  }

  await timeout(0)

  // COMPLETE
  store.commit('app/setLoadState', LOAD.STATES.COMPLETE)
  store.dispatch('app/getVersion')
}

// ********************************************************
//
// INIT
//
// ********************************************************
initApp()
